import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './classes/CourseandConferenceBlock.css';
import './classes/ConferencesBlock.css';
import { configData } from "../config";

// The "Upcoming Conferences & Events" list on the Conferences page, 10 a page.
// The page number is kept in the url as ?page=N (0 = first page), as on the Drupal site.
const ConferencesBlock = () => {
    const app_url = configData.APP_URL;
    const location = useLocation();
    const pageNo = Math.max(0, parseInt(new URLSearchParams(location.search).get('page'), 10) || 0);

    const [conferences, setConferences] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [playVideo, setPlayVideo] = useState(false);

    useEffect(() => {
        getconferences(pageNo);
    }, [pageNo]);

    const getconferences = async (page) => {
        try {
            const response = await fetch(app_url + 'pages/getconferences?page=' + page, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const responsedata = await response.json();
            if (responsedata.data?.items) {
                setConferences(responsedata.data.items);
                setPageCount(Math.max(1, Math.ceil(responsedata.data.total / responsedata.data.per_page)));
            }
        } catch (err) {
            console.error(err);
        }
    };

    const pageLink = (page) => location.pathname + (page > 0 ? '?page=' + page : '');

    return (
        <div id="conferences-block" className="conference-section conferences-block">
            <h2>UPCOMING CONFERENCES &amp; EVENTS</h2>

            <ul className="conference-list">
                {conferences.map((conference) => (
                    <li className="conference-list__item" key={conference.nid}>

                        {/* ---------------- Desktop Tile ---------------- */}
                        <div className="conference-tile--desktop">

                            <div className="conference-list__item-image-wrapper">
                                <a href={conference.link}>
                                    {conference.image && <img src={conference.image} alt={conference.title} loading="lazy" />}
                                </a>
                            </div>

                            <div className="conference-list__item-details">
                                <div className="conference-list__item-title title">
                                    <a href={conference.link}>{conference.title}</a>
                                </div>

                                <div className="conference-list__item-intro">
                                    {conference.intro}
                                </div>

                                <div className="conference-list__item-location">
                                    <a href={conference.link}>{conference.location}</a>
                                </div>
                            </div>

                            <div className="conference-list__item-deadline">
                                <div className="conference-list__item-deadline-badge">
                                    <span className="badge__header">{conference.month}</span>
                                    <span className="badge__day">
                                        {conference.day}
                                        <span className="badge__year">{conference.year}</span>
                                    </span>
                                    <span className="badge__month">Conference</span>
                                    <span className="badge__label">Start Date</span>
                                </div>

                                <div className="conference-list__item-badge-accent">
                                    <a href={conference.link}>
                                        <span className="badge__learn-more">LEARN MORE</span>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* ---------------- Mobile Tile ---------------- */}
                        <div className="conference-tile--mobile">
                            <div className="views-field-wrap">
                                <div className="conference-list__item-mobile-header">
                                    <div className="conference-list__item-avatar">
                                        <i>
                                            {conference.mobile_icon && <img src={conference.mobile_icon} alt="" loading="lazy" />}
                                        </i>
                                    </div>

                                    <div className="conference-list__item-title title">
                                        <a href={conference.link}>{conference.title}</a>
                                    </div>
                                </div>

                                <div className="conference-list__item-deadline-badge">
                                    <div className="badge__date">{conference.conference_date}</div>
                                    <div className="badge__status">{conference.location}</div>
                                    <div className="badge__description">{conference.description}</div>

                                    <div className="badge__action-container">
                                        <span className="badge__action-btn">
                                            <a href={conference.link}>LEARN MORE</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </li>
                ))}
            </ul>

            {pageCount > 1 && (
                <ul className="conferences-pager">
                    {pageNo > 0 && (
                        <>
                            <li><Link to={pageLink(0)} title="Go to first page">« first</Link></li>
                            <li><Link to={pageLink(pageNo - 1)} title="Go to previous page">‹ previous</Link></li>
                        </>
                    )}
                    {Array.from({ length: pageCount }, (_, page) => (
                        page === pageNo
                            ? <li className="pager-current" key={page}>{page + 1}</li>
                            : <li key={page}><Link to={pageLink(page)} title={'Go to page ' + (page + 1)}>{page + 1}</Link></li>
                    ))}
                    {pageNo < pageCount - 1 && (
                        <>
                            <li><Link to={pageLink(pageNo + 1)} title="Go to next page">next ›</Link></li>
                            <li><Link to={pageLink(pageCount - 1)} title="Go to last page">last »</Link></li>
                        </>
                    )}
                </ul>
            )}

            {/* The conference video under the list: the picture is swapped for the player on click */}
            <div className="conferences-video">
                {playVideo ? (
                    <iframe
                        src="https://www.youtube.com/embed/980kcUxLCaI?autoplay=1"
                        title="SMWW Career Conferences"
                        frameBorder="0"
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                    />
                ) : (
                    <button type="button" className="conferences-video__poster" onClick={() => setPlayVideo(true)} aria-label="Play video">
                        <img src="https://i.ytimg.com/vi/980kcUxLCaI/sddefault.jpg" alt="" loading="lazy" />
                        <span className="conferences-video__play" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default ConferencesBlock;
